export default __webpack_public_path__ + "static/media/Copy-Account.11574350.png";